import type {ReactElement} from 'react';
import {Button, IconPlacement, Size, Type} from '@Components/button/button';
import type {AdminControlButtonProps} from './admin-control-button.types';
import styles from './admin-control-button.module.scss';

export function AdminControlButton({label, icon, onClick}: AdminControlButtonProps): ReactElement {
  return <Button type={Type.SECONDARY} size={Size.SMALL} icon={icon} iconPlacement={IconPlacement.LEFT} text={label} isFullWidth onClick={onClick} customClasses={styles.button} />;
}
